<div class="container">
  <div class="container-text">
    <ppl-icon
      svgIcon="info-completed"
      width="18px"
      height="18px"></ppl-icon>
    <p>{{ message }}</p>
  </div>
  @if (actionText) {
    <div class="container-actions">
      <button
        pplButton
        pplButton4
        pplButtonSmall
        (click)="onActionClicked()">
        {{ actionText }}
      </button>
    </div>
  }
  @if (showClose) {
    <div class="container-close">
      <button
        (click)="onClose()"
        class="icon-button">
        <ppl-icon
          svgIcon="closering-red-white"
          height="16px"
          width="16px"></ppl-icon>
      </button>
    </div>
  }
</div>
